import React, { Component } from 'react';
import { Request } from '../../components/Request';
import ActiveSelectableButton from '../elements/ActiveSelectableButton';
import { StreamComponent } from './StreamComponent';
import LoaderFullPage from '../elements/LoaderFullPage';

export default class StreamPopupCard extends Component {
	constructor(props) {
		super(props);
		this.streamEmbed = this.streamEmbed.bind(this);
		this.followLink = this.followLink.bind(this);
		this.onPreviewImageError = this.onPreviewImageError.bind(this);
		this.onPreviewImageLoad = this.onPreviewImageLoad.bind(this);

		this.state = {
			loading: false,
			imageLoading: true,
			imageLoadError: false,
		};

		this.doNothing = () => {
		};
	}

	componentDidMount() {
		const { activePopup } = this.props;
		if(activePopup.isPreviewable()) {
			return;
		}
		this.setState({
			loading: true
		});
		activePopup.loadPreviewData()
			.then(() => {
				this.setState({
					loading: false
				});
				this.forceUpdate();
			});
	}

	onPreviewImageLoad() {
		const { popupResizeProbablyHappened } = this.props;
		this.setState({
			imageLoading: false
		});
		popupResizeProbablyHappened();
	}

	onPreviewImageError() {
		const { popupResizeProbablyHappened } = this.props;
		this.setState({
			imageLoading: false,
			imageLoadError: true,
		});
		popupResizeProbablyHappened();
	}

	followLink() {
		const { activePopup } = this.props;
		activePopup.followLink();
	}

	streamEmbed() {
		const { activePopup, closePopup } = this.props;
		const stream = $('#visible_stream');
		const bottomDock = $('#bottom_dock').addClass('streaming');
		stream.show();
		stream.addClass('loading');
		const data = {
			literal: activePopup.literal,
			stream_name: activePopup.channel_name
		};

		closePopup();
		Request.apiv1Get('stream/fetch', data)
			.then((response) => {
				response = response.stream;
				// closePopup();
				stream.removeClass('loading');
				stream.show();
				bottomDock.addClass('streaming');
				if(response.channel_name) {
					stream.find('.name').text(response.channel_name);
				}
				else {
					stream.find('.name').text(response.channel_id);
				}
				stream.find('.stream_title').text(response.title);
				console.log(stream);
				console.log(stream.find('.embed_holder'));
				console.log(response.embed);
				stream.find('.embed_holder').html(response.embed);
			})
			.catch((error) => {
				Request.generalJsonError(error);
				$('#bottom_dock').removeClass('streaming');
				stream.removeClass('loading');
				stream.hide();
			});
	}


	//
	// componentDidMount() {
	// 	this.updateHeight();
	// }
	//
	// componentDidUpdate() {
	// 	this.updateHeight();
	// }
	//
	// componentWillUnmount() {
	// }
	//
	// updateHeight() {
	// 	console.log('what am popup', this.popup);
	// 	if(!this.popup.current) {
	// 		return;
	// 	}
	// 	console.log('what is clientHeight', this.popup.current.clientHeight);
	// 	if(this.state.height !== this.popup.current.clientHeight) {
	// 		this.setState({
	// 			height: this.popup.current.clientHeight,
	// 			width: this.popup.current.clientWidth
	// 		});
	// 	}
	// }

	render() {
		const { activePopup } = this.props;
		const { loading, imageLoading } = this.state;
		const isImage = activePopup.type === 'image';
		return (
			<div
				key={imageLoading}
				className='stream_action panel-body'>
				{!isImage &&
				<h4 className='page-sub-heading no-margin-top'>{activePopup.channel_name}</h4>
				}
				{!isImage &&
				<div className='flex flex-space-between flex-row'>
					{activePopup.isEmbedable() &&
					<ActiveSelectableButton
						onClick={this.streamEmbed}
						small
					>
						In Site Popup
					</ActiveSelectableButton>
					}
				</div>
				}
				{!loading && activePopup.isPreviewable() &&
				<div className='row'>
					<div className='row'>
						<a href={activePopup.getUrl()} target='_blank'>
							<StreamComponent
								stream={activePopup}
								showGame={false}
								showChannelName={false}
								clickable={!isImage}
								onClick={this.doNothing}
								onPreviewImageLoad={this.onPreviewImageLoad}
								onPreviewImageError={this.onPreviewImageError}
							/>
						</a>
					</div>
				</div>
				}
				{loading &&
				<LoaderFullPage />
				}
			</div>
		);
	}
}